import $ from 'jquery'
import Glide from '@glidejs/glide'

export default {
  init() {
    new Glide('.glide', {
      gap: 0,
      autoplay: 4000,
      animationDuration: 1000
    }).mount()

    $(window).on('scroll', this.setSidebarPosition)
    $(window).on('resize', this.setSidebarPosition)
    this.setSidebarPosition()

    let isOpen = false

    $('.sidebar__close').on('click', () => {
      if (isOpen) {
        $('.wines__sidebar').removeClass('open')
        $('.sidebar__close i').removeClass('icon-burger-close')
        $('.sidebar__close i').addClass('icon-burger')
      } else {
        $('.wines__sidebar').addClass('open')
        $('.sidebar__close i').addClass('icon-burger-close')
        $('.sidebar__close i').removeClass('icon-burger')
      }
      
      isOpen = !isOpen
    })
  },
  setSidebarPosition() {
    console.log(window.scrollY + 120 + 60 + $('.sidebar').height() > $('.wines__sidebar').offset().top + $('.wines__sidebar').height() )

    const startListPosition = $('.wines__sidebar').offset().top - 120
    const endListPosition = $('.wines__sidebar').offset().top + $('.wines__sidebar').height() - 180 - $('.sidebar').height()

    if (window.scrollY < startListPosition) {
      $('.sidebar').removeClass('sidebar--sticky')
      $('.sidebar').removeClass('sidebar--absolute')
    } else if (window.scrollY >= startListPosition && window.scrollY < endListPosition) {
      $('.sidebar').addClass('sidebar--sticky')
      $('.sidebar').removeClass('sidebar--absolute')
    } else {
      $('.sidebar').addClass('sidebar--absolute')
      $('.sidebar').removeClass('sidebar--sticky')
    }
  }, 
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
